import React, { useMemo, useState, useRef, useEffect } from "react";
import { FixedSizeList as List } from "react-window";
import { countries } from "../../../services/PostsService";
import { useDispatch } from "react-redux";
import { locationFilterPost } from "../../../store/actions/FilterActions";

export default function CountryPicker({
  selectedCountry,
  setSelectedCountry,
  onSelect,
}) {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  const filteredCountries = useMemo(() => {
    return Object.keys(countries).filter((key) =>
      countries[key].name.common
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const handleSelect = (name) => {
    onSelect(name);
    dispatch(locationFilterPost(name));
    setSearchTerm(name); // Show in input
    setShowDropdown(false);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const Row = ({ index, style }) => {
    const countryKey = filteredCountries[index];
    const country = countries[countryKey];

    return (
      <div
        className="dropdown-item d-flex justify-content-between align-items-center"
        style={{ ...style, cursor: "pointer" }}
        onClick={() => handleSelect(country.name.common)}
      >
        <span>{country.name.common}</span>
        <img
          src={country.flag}
          alt=""
          style={{
            width: "20px",
            height: "15px",
            objectFit: "cover",
            borderRadius: "2px",
          }}
        />
      </div>
    );
  };

  return (
    <div className="position-relative w-100" ref={wrapperRef}>
      <input
        type="text"
        className="form-control"
        placeholder="All"
        value={searchTerm || selectedCountry || ""}
        onFocus={() => {
          setShowDropdown(true);
          setSearchTerm("");
        }}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          if (e.target.value === "") {
            setSelectedCountry("");
          }
        }}
      />
      {showDropdown && (
        <div
          className="dropdown-menu show mt-1 p-0 w-100 border rounded shadow-sm"
          style={{ maxHeight: "300px", overflow: "hidden", zIndex: 1000 }}
        >
          {filteredCountries.length > 0 ? (
            <>
              <div
                className="dropdown-item d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleSelect("")}
              >
                All
              </div>
              <div
                className="dropdown-item d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleSelect("Excluding Singapore")}
              >
                Excluding Singapore
              </div>
              <List
                height={300}
                itemCount={filteredCountries.length}
                itemSize={40}
                width="100%"
              >
                {Row}
              </List>
            </>
          ) : (
            <div className="dropdown-item text-muted">No countries found</div>
          )}
        </div>
      )}
    </div>
  );
}
